import AppToolbar from '@/components/common/AppToolbar.vue'

export default {
  components: {
    AppToolbar
  },

  mixins: [],

  data() {
    return {
      toolbarNavigationItems: [],
      toolbarTitle          : ''
    }
  },

  computed: {},

  created() {
    this.$bus.$on('toolbar-update-title', this.updateTitle)

    if (this.$route.name !== 'Login' && this.$route.matched.length > 0) {
      this.$bus.$emit('toolbar-update-title', this.$route.matched[0].meta.title)
    }

  },

  beforeDestroy() {
    this.$bus.$off('toolbar-update-title', this.updateTitle)
  },

  methods: {
    updateTitle(val) {
      this.toolbarTitle = val
    }
  }
}
